import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    title: 'Plan práctico de entrenamiento',
    value: '$18.990',
    image: 'https://cdn.magicpatterns.com/uploads/1g5ZT5yv2uBTMPHXiYEpt1/Premium_Ebook_Cover_with_Balanced_Line_Art.png',
    alt: 'Bono 1 - Complemento Práctico'
  }, {
    title: 'Guía de alimentación simple',
    value: '$18.990',
    image: 'https://cdn.magicpatterns.com/uploads/w7uLn5GfmJf85CV75gr2jy/Elegant_Ebook_Cover_with_Dynamic_Elements.png',
    alt: 'Bono 2 - Dieta Sin Complicaciones'
  }, {
    title: '50 rutinas en casa',
    value: '$14.990',
    image: 'https://cdn.magicpatterns.com/uploads/nLyMwc7TUSRLbfDnMGygBz/Vibrant_Fitness_Ebook_with_Squat_Pose.png',
    alt: 'Bono 3 - 50 Rutinas en Casa'
  }, {
    title: 'Sistema de disciplina automática',
    value: '$14.990',
    image: 'https://cdn.magicpatterns.com/uploads/7Mx5TaU7jUgXFRANpR3R1n/Sophisticated_Ebook_Cover_with_Premium_Elements.png',
    alt: 'Bono 4 - Sistema de Disciplina Automática'
  }, {
    title: 'La verdad científica detrás de un cambio físico real',
    value: '$19.990',
    image: 'https://cdn.magicpatterns.com/uploads/pj6FhZ67TbcRULVby6ywJL/Dynamic_Scientific_Fitness_Ebook_Design.png',
    alt: 'Bono 5 - La Verdad Científica de Cambio Físico Real'
  }, {
    title: 'Energía, foco, mentalidad',
    value: '$14.990',
    image: 'https://cdn.magicpatterns.com/uploads/jwnFie2PrM3RJqgmYjF9ru/Glowing_Brain_with_Upward_Motion_Title.png',
    alt: 'Bono 6 - Energía, Foco y Mentalidad'
  }];
  return <section className="py-24 bg-gray-900 text-white relative overflow-hidden" data-id="element-24">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-rose-500/10 blur-[120px] rounded-full pointer-events-none" data-id="element-25" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-26">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-27">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-rose-500/20 text-rose-400 mb-6" data-id="element-28">
            <Gift className="w-8 h-8" data-id="element-29" />
          </div>
          <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-30">
            Solo por hoy recibís además{' '}
            <span className="text-rose-400" data-id="element-31">6 bonos gratis</span>
          </h2>
          <p className="text-xl text-gray-400" data-id="element-32">
            Complementos exclusivos para acelerar tus resultados.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-33">
          {bonuses.map((bono, index) => <motion.div key={index} className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden backdrop-blur-sm hover:bg-white/10 transition-colors" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} data-id="element-34">
              <div className="w-full aspect-[3/4] overflow-hidden bg-gray-800" data-id="element-35">
                <img src={bono.image} alt={bono.alt} className="w-full h-full object-cover" data-id="element-36" />
              </div>
              <div className="p-6" data-id="element-37">
                <div className="text-rose-400 font-bold text-sm tracking-wider uppercase mb-2" data-id="element-38">
                  BONO {index + 1}
                </div>
                <h3 className="text-xl font-bold mb-4 min-h-[56px]" data-id="element-39">
                  {bono.title}
                </h3>
                <div className="flex items-center justify-between pt-4 border-t border-white/10" data-id="element-40">
                  <span className="text-gray-400 line-through text-sm" data-id="element-41">
                    Valor: {bono.value}
                  </span>
                  <span className="text-green-400 font-bold" data-id="element-42">GRATIS</span>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}